import React from 'react';
import {
  Box,
  Button,
  Flex,
  Link,
  Stack,
  SvgX,
} from '@grubhubprod/gh-cookbook-react';
import { PageSection } from 'src/components/selfService/layout/PageSection/PageSection';
import { PageSectionTitle } from 'src/components/selfService/layout/PageSectionTitle/PageSectionTitle';
import { useScreenSizes } from 'src/utilities/useScreenSizes';
import { BalancePortalButton } from 'src/components/selfService/common/Balance/components/BalancePortalButton/BalancePortalButton';
import { BalancePortalPage } from 'src/components/selfService/common/Balance/balance.types';
import { useBalanceContext } from 'src/components/selfService/common/Balance/hooks/useBalanceContext';
import { useLocalStorageDismiss } from 'src/components/selfService/common/Balance/hooks/useLocalStorageDismiss';

export function NetTermsPromotionSection(): JSX.Element {
  const { isPhone } = useScreenSizes();
  const balanceContext = useBalanceContext();
  const { isNetTermsPromotionDismissed, dismissNetTermsPromotion } =
    useLocalStorageDismiss();

  if (
    balanceContext.isCreditInfoLoading ||
    balanceContext.isOnNetTerms ||
    isNetTermsPromotionDismissed
  ) {
    return null;
  }

  const DismissBunnerButton = (): JSX.Element => (
    <Button variant="tertiary" type="button" onClick={dismissNetTermsPromotion}>
      <SvgX aria-label="close" size="24px" />
    </Button>
  );

  return (
    <Stack y="md" position="relative">
      {isPhone && (
        <Box position="absolute" top="6px" right="3px">
          <DismissBunnerButton />
        </Box>
      )}

      <PageSection
        dataTestId="net-terms-promotion-section"
        borderRadius="16px"
        bg="tintMint"
      >
        <Flex
          alignItems="center"
          justifyContent="space-between"
          flexDirection={isPhone ? 'column' : 'row'}
          style={{
            gap: isPhone ? '24px' : '64px',
          }}
        >
          <Box flex="1">
            <PageSectionTitle
              y="none"
              title="Enjoy financial flexibility with net terms"
              headingVariant="h3"
              subtitleY="xxx-sm"
              subtitle={
                <>
                  {`Upgrade your payment method to net terms invoicing through
                  Balance, so you can better manage your cash flow. Apply now to
                  get started. `}
                  <Link
                    href="https://www.google.com" // TODO change after Product Team provides the link
                    target="_blank"
                    variant="muted"
                  >
                    Learn more
                  </Link>
                </>
              }
            />
          </Box>

          <Flex alignItems="center" width={isPhone ? '100%' : 'auto'}>
            <BalancePortalButton
              balancePortalPage={BalancePortalPage.OUTSTANDING_INVOICES}
              text="Apply Now"
              block
              fullWidth={isPhone}
            />
            {!isPhone && <DismissBunnerButton />}
          </Flex>
        </Flex>
      </PageSection>
    </Stack>
  );
}
